import { makeStyles } from "@material-ui/core"
import { themeColors, FONT } from "letalkui"

const useStyles = makeStyles(theme => ({
	takeAttendanceText: {
		textDecoration: "underline",
		cursor: "pointer"
	},
	messageWasteWarningContainer: {
		marginTop: theme.spacing(1)
	},
	messageWasteWarningIconContainer: {
		marginTop: 2
	},
	messageWasteWarningIcon: {
		width: 15,
		height: 15,
		color: themeColors.colors.system.yellow[800],
		display: "block"
	},
	messageWasteWarningText: {
		color: themeColors.colors.system.yellow[800],
		fontSize: FONT.size.smaller2
	},
	messageWasteWarningLink: {
		color: themeColors.colors.system.purple[500],
		fontWeight: FONT.fontWeight.semibold,
		cursor: "pointer",
		textDecoration: "underline"
	},
	inputItemContainer: {
		flex: 1,
		paddingRight: theme.spacing(2),
		position: "relative"
	},
	"@keyframes fadeInOut": {
		"0%": {
			opacity: 1
		},
		"25%": {
			opacity: 0.75
		},
		"50%": {
			opacity: 0.5
		},
		"75%": {
			opacity: 0.75
		},
		"100%": {
			opacity: 1
		}
	},
	fadeInOutAnimation: {
		animation: "$fadeInOut 2s infinite"
	}
}))

export default useStyles
